<div class="wrapper">
    <div class="loading">
        <img src="assets/diamond_img/loading.gif" alt="" class="mCS_img_loaded">
    </div>
    <app-header></app-header>
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
                <div class="col-12 hide-large featured-box">
                    <ul class="nav nav-tabs sport-tab">
                        <li class="nav-item"><a class="nav-link active" (click)="goToAll('All')">Home</a></li>
                        <li class="nav-item"><a class="nav-link" (click)="inplay()">In-Play</a></li>
                        <!-- <li class="nav-item"><a class="nav-link" (click)="multi()">Multi Markets</a></li> -->
                        <li class="nav-item" *ngFor="let sports of allSportsList;let i= index"
                          (click)="goToDashboard(sports.name,sports.sport_id,sports)"><a class="nav-link"
                            [ngClass]="{'newlaunch':sports.sport_id <= -100 }">{{sports.name == 'Soccer' ? 'Football' : sports.name}}</a></li>
                    </ul>
                </div>
                <div class="col-md-10 featured-box">
                    <div>
                        <div class="pb-4 mobilepb-0">
                            <ul role="tablist" id="home-events" class="nav nav-tabs">
                                <li class="nav-item" *ngFor="let sports of mobileAllSportsList;let i= index" (click)="goToDashboard(sports.name,sports.sport_id,sports)">
                                    <a href="javascript:void(0)" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#home-tab" role="tab" class="nav-link" [ngClass]="{'newlaunch':sports.sport_id <= -100 }" [class.active]='sportName == sports.name'>
                                        <img src="assets/images/icon/{{sports.sport_id}}.png" alt="" class="hide-large"> {{sports.name == 'Soccer' ? 'Football' : sports.name}}
                                    </a>
                                </li>
                            </ul>
                            <div class="tab-content" >
                                <div class="tab-pane fade show active" id="home-tab" role="tabpanel" aria-labelledby="nav-home-tab" tabindex="0">
                                    <div class="coupon-card coupon-card-first mobile-scroll">
                                        <div class="card-content" >
                                            <table class="table coupon-table mobile-coupon-table">
                                                <thead class="hide-small">
                                                    <tr>
                                                        <th style="width: 63%;">Game</th> 
                                                        <th colspan="2">1</th> 
                                                        <th colspan="2">X</th> 
                                                        <th colspan="2">2</th>
                                                    </tr>
                                                </thead>
                                               <tbody>
                                                    <tr>
                                                        <td colspan="7" class="text-center">No real-time records found</td>
                                                    </tr>
                                               </tbody> 
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="home-products-container">
                            <div class="row row5 hide-large">
                                <div class="col-md-12">
                                    <h4 class="text-uppercase pb-3">Our Casino</h4>
                                </div>
                            </div>
                            <div class="row row5">
                                <div class="col-md-12 casino-list">
                                    <a *ngFor="let list of exchangeGameList;let i = index; ">
                                        <div class="d-inline-block casinoicons" (click)="gotoexchangeGame(list)">
                                            <img src="assets/lotus-images/{{list?.match_id}}.jpg" class="img-fluid">
                                            <div class="casino-name">{{list?.match_name}}</div>
                                            <!-- <div class="new-launch-casino"><img src="assets/diamond_img/offer-patch.png" class="hide-small">
                                                <span class="hide-large">New Launch</span>
                                            </div> -->
                                        </div>
                                    </a>
                                    <!-- <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Race 20-20</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/queen.jpg" class="img-fluid">
                                            <div class="casino-name">Casino Queen</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/cricketv3.jpg" class="img-fluid">
                                            <div class="casino-name">5Five Cricket</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/andar-bahar2.jpg" class="img-fluid">
                                            <div class="casino-name">Andar Bahar 2</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">20-20 Dragon Tiger 2</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Baccarat 2</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Baccarat</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Lucky 7 - B</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Teenpatti 2.0</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">20-20 Cricket Match</div>
                                        </div>
                                    </a>
                                    <a>
                                        <div class="d-inline-block casinoicons">
                                            <img src="assets/diamond_img/race20.png" class="img-fluid">
                                            <div class="casino-name">Casino Meter</div>
                                        </div>
                                    </a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>
</div>